module.exports = __webpack_public_path__ + "static/media/golfing.5b6897ac.png";